export const DRILLDOWN_GROUP_LABEL_TRANSLATIONS = {
  'Offer ID': $localize`:@@offer.id:Offer ID`,
  'Advertiser ID': $localize`:@@advertiser.id:Advertiser ID`,
  Brand: $localize`:@@common.brand:Brand`,
  Country: $localize`:@@common.country:Country`,
  'Affiliate Consolidation': $localize`:@@affiliate.consolidation:Affiliate Consolidation`,
  'Device Brand': $localize`:@@common.device_brand:Device Brand`,
  'Device Model': $localize`:@@common.device_model:Device Model`,
  'Device OS': $localize`:@@common.device_os:Device OS`,
  Browser: $localize`:@@common.browser:Browser`,
  Platform: $localize`:@@common.platform:Platform`,
  'Device OS Version': $localize`:@@common.device_os_version:Device OS Version`,
  'Goal Type': $localize`:@@common.goal_type:Goal Type`,
  'Payout Model ID': $localize`:@@common.payout_model_id:Payout Model ID`,
  'Revenue Model ID': $localize`:@@common.revenue_model_id:Revenue Model ID`,
  Daily: $localize`:@@dates.daily:Daily`,
  Hourly: $localize`:@@dates.hourly:Hourly`,
  Yearly: $localize`:@@dates.yearly:Yearly`,
  Monthly: $localize`:@@dates.monthly:Monthly`,
  Weekly: $localize`:@@dates.weekly:Weekly`,
  'Sale Status': $localize`:@@common.sale_status:Sale Status`,
  'Affiliate ID': $localize`:@@affiliate.id:Affiliate ID`,
  'Affiliate Manager ID': $localize`:@@affiliate.manager_id:Affiliate Manager ID`,
  'Offer Url ID': $localize`:@@offer.url_id:Offer URL ID`,
  'Goal ID': $localize`:@@goal.id:Goal ID`,
  'Affiliate Group': $localize`:@@affiliate.group:Affiliate Group`,
  'Traffic Source': $localize`:@@offer.traffic_source:Traffic Source`,
  Category: $localize`:@@common.category:Category`,
  Vertical: $localize`:@@offer.vertical:Vertical`,
  'Affiliate Source': $localize`:@@affiliate.source:Affiliate Source`,
};

export const DRILLDOWN_GROUP_RELATION_TRANSLATIONS = {
  'Affiliate ID': $localize`:@@affiliate.id:Affiliate ID`,
  'Advertiser ID': $localize`:@@advertiser.id:Advertiser ID`,
  'Offer ID': $localize`:@@offer.id:Offer ID`,
};

export const DRILLDOWN_RELATION_LABEL_TRANSLATIONS = {
  Advertiser: $localize`:@@common.advertiser:Advertiser`,
  Affiliate: $localize`:@@common.affiliate:Affiliate`,
  Offer: $localize`:@@common.offer:Offer`,
  'Affiliate ID': $localize`:@@affiliate.id:Affiliate ID`,
  'Advertiser ID': $localize`:@@advertiser.id:Advertiser ID`,
  'Offer ID': $localize`:@@offer.id:Offer ID`,
};

export const DRILLDOWN_RELATION_FIELD_TRANSLATIONS = {
  Address: $localize`:@@common.address:Address`,
  'First Name': $localize`:@@common.first_name:First Name`,
  'Last Name': $localize`:@@common.last_name:Last Name`,
  Name: $localize`:@@common.name:Name`,
  Phone: $localize`:@@common.phone:Phone`,
  Company: $localize`:@@common.company:Company`,
  'Created At': $localize`:@@common.created_at:Created At`,
  'Last Seen': $localize`:@@common.last_seen:Last Seen`,
  'Microsoft Teams (formerly Skype)': $localize`:@@common.ms_teams_formerly_skype:Microsoft Teams (formerly Skype)`,
};
